import {
  ref
} from 'vue'

export const useRecaptcha = () => {
  const recaptchaToken = ref(null)
  let run = false

  const initializeRecaptcha = (action = 'inquiry') => {
    if (run || recaptchaToken.value) {
      return
    }
    run = true

    if (typeof(grecaptcha) == 'undefined') {
      run = false
      setTimeout(initializeReCaptcha, 1000)
      return
    }

    grecaptcha.ready(() => {
      grecaptcha.execute(window.app.common.recaptchaSiteKey, { action }).then((token) => {
        recaptchaToken.value = token
      })
    })
  }

  return {
    // variables
    recaptchaToken,
    // methods
    initializeRecaptcha,
  }
}
